import script from "./ContentImageText.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContentImageText.vue?vue&type=script&setup=true&lang=ts"

import "./ContentImageText.vue?vue&type=style&index=0&id=f4a06546&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4a06546"]])

export default __exports__